import {reactive} from "vue";

const context = reactive({})

export const defineFlow = (flow = {
	name: '',
	component: '',
	title: '',
	props: {},
	params: {},
}) => {
	context[flow.name] = flow
}
defineFlow({
	name: 'THEN',
	title: '串行',
	component: 'SerialNode',
	props: {},
	params: {},
	nodes: ['SELECT_ONE', 'SELECT_LIST', 'SAVE', 'SET', 'IF', 'INV_FLOW', 'HTTP', 'ITERATOR', 'T_NODE', 'SCRIPT_NODE'],
})
defineFlow({
	name: 'START',
	title: '开始',
	icon: 'el-icon-document',
	component: 'FlowNode',
	props: {
		titleStyle: 'background:#579589',
		hideClose: true
	},
	params: {},
	default: () => ({
		id: '_'+new Date().getTime().toString(),
		name: 'T_NODE',
		params: {},
		children: []
	})
})
defineFlow({
	name: 'SELECT_ONE',
	title: '查询单条数据',
	icon: 'el-icon-document',
	component: 'FlowNode',
	props: {
		titleStyle: 'background:#979589',
	},
	params: {
		title: {
			title: '标题',
			type: 'string'
		},
		sql: {
			title: '查询语句',
			type: 'string',
			props: {
				placeholder: 'SQL语句'
			}
		},
		arg: {
			title: '保存到',
			type: 'string',
			props: {
				placeholder: '保存结果的变量名称'
			}
		}
	},
	default: () => ({
		id: '_'+new Date().getTime().toString(),
		name: 'T_NODE',
		params: {},
		children: []
	})
})
defineFlow({
	name: 'SELECT_LIST',
	title: '查询多条数据',
	icon: 'el-icon-document',
	component: 'FlowNode',
	props: {
		titleStyle: 'background:#979589',
	},
	params: {},
	default: () => ({
		id: '_'+new Date().getTime().toString(),
		name: 'T_NODE',
		params: {},
		children: []
	})
})
defineFlow({
	name: 'INV_FLOW',
	title: '自定义接口',
	icon: 'el-icon-document',
	component: 'FlowNode',
	props: {
		titleStyle: 'background:#979589',
	},
	params: {
		name: {
			title: '接口名',
			type: 'string',
			props: {
				placeholder: '请输入接口名称'
			}
		},
		params: {
			title: '参数',
			type: 'params',
			props: {
				placeholder: '参数信息'
			}
		}
	},
	default: () => ({
		id: '_'+new Date().getTime().toString(),
		name: 'T_NODE',
		params: {},
		children: []
	})
})
defineFlow({
	name: 'HTTP',
	title: '发起请求',
	icon: 'el-icon-document',
	component: 'FlowNode',
	props: {
		titleStyle: 'background:#979589',
	},
	params: {
		url: {
			title: 'URL',
			type: 'string',
			props: {
				placeholder: '请输入URL'
			}
		},
		method: {
			title: '方法',
			type: 'enum',
			props: {
				items: [
					{value: 'GET', label: 'GET'},
					{value: 'POST ', label: 'POST'},
					{value: 'PUT ', label: 'PUT'},
					{value: 'DELETE ', label: 'DELETE'},
				]
			}
		},
		params: {
			title: '参数',
			type: 'params',
			props: {
				placeholder: '参数信息'
			}
		}
	},
	default: () => ({
		id: '_'+new Date().getTime().toString(),
		name: 'T_NODE',
		params: {},
		children: []
	})
})
defineFlow({
	name: 'SAVE',
	title: '保存数据',
	icon: 'el-icon-document',
	component: 'FlowNode',
	props: {
		titleStyle: 'background:#979589',
	},
	params: {},
	default: () => ({
		id: '_'+new Date().getTime().toString(),
		name: 'SAVE',
		params: {},
		children: []
	})
})
defineFlow({
	name: 'SET',
	title: '修改数据',
	icon: 'el-icon-document',
	component: 'FlowNode',
	props: {
		titleStyle: 'background:#979589',
	},
	params: {
		title: {
			title: '标题',
			type: 'string'
		},
		name: {
			title: '变量名',
			type: 'string',
			props: {
				placeholder: '支持 a.b.c'
			}
		},
		value: {
			title: '赋值为',
			type: 'string',
			props: {
				placeholder: '支持变量 a.b.c'
			}
		}
	},
	default: () => ({
		id: '_'+new Date().getTime().toString(),
		name: 'T_NODE',
		params: {},
		children: []
	})
})
defineFlow({
	name: 'T_NODE',
	title: '普通节点',
	icon: 'el-icon-document',
	component: 'FlowNode',
	props: {},
	params: {},
	default: () => ({
		id: '_'+new Date().getTime().toString(),
		name: 'T_NODE',
		params: {},
		children: []
	})
})
defineFlow({
	name: 'SCRIPT_NODE',
	type: 'script',
	title: '自定义节点',
	icon: 'el-icon-document',
	component: 'FlowNode',
	props: {},
	params: {},
	default: () => ({
		id: '_'+new Date().getTime().toString(),
		name: 'SCRIPT_NODE',
		type:'script',
		language:'javascript',
		description:'自定义节点,点击编辑脚本',
		script:'console.log("我是自定义节点")',
		params: {},
		children: []
	})
})
defineFlow({
	name: 'COND',
	title: '条件节点',
	icon: 'el-icon-document',
	component: 'ConditionNode',
	props: {},
	params: {
		title: {
			title: '标题',
			type: 'string'
		},
		condition: {
			title: '条件',
			type: 'string'
		}
	},
	nodes: ['T_NODE', 'IF'],
	default: () => ({
		id: '_'+new Date().getTime().toString(),
		name: 'COND',
		params: {},
		children: []
	})
})
defineFlow({
	name: 'IF',
	title: '条件',
	icon: 'el-icon-document',
	component: 'BranchNode',
	props: {},
	params: {},
	default: () => ({
		id: '_'+new Date().getTime().toString(),
		name: 'IF',
		params: {},
		children: [
			{
				id: '_'+new Date().getTime().toString(),
				name: 'COND',
				params: {},
				children: []
			},
		]
	})
})
defineFlow({
	name: 'ITERATOR',
	title: '迭代器',
	icon: 'el-icon-document',
	component: 'IteratorNode',
	props: {
		titleStyle: 'background:#979589',
	},
	params: {
		title: {
			title: '标题',
			type: 'string'
		},
		value: {
			title: '值',
			type: 'string',
			props: {
				placeholder: '变量名'
			}
		}
	},
	nodes: ['SELECT_ONE', 'SELECT_LIST', 'SAVE', 'SET', 'IF'],
	default: () => ({
		id: (new Date().getTime() + 10).toString(),
		name: 'ITERATOR',
		params: {},
		children: []
	})
})
export const getFlow = (name) => {
	return context[name]
}
